import { Box } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "./Link";

const SUMMARY_CLASS = "details-summary";
const WRAPPER_CLASS = "details-wrapper";

const summaryOnClick = (event: Event) => {
  event.preventDefault();

  const summary = event.currentTarget as HTMLElement | null;
  const id = summary?.dataset.id;
  const wrapper = summary?.nextElementSibling as HTMLElement | null | undefined;

  if (
    !summary ||
    !id ||
    !wrapper ||
    !wrapper.classList.contains(WRAPPER_CLASS)
  ) {
    console.error("failed to onclick", { event, summary, id, wrapper });
    return;
  }

  if (!wrapper.firstElementChild) {
    const originalDetails = document.getElementById(id);

    if (originalDetails) {
      const details = originalDetails.cloneNode(true) as HTMLElement;
      details.id = "";
      wrapper.appendChild(details);
      addSummaryListeners(details);
    } else {
      console.error("failed to find details", { event, summary, id, wrapper });
      return;
    }
  }

  const details = wrapper.firstElementChild as HTMLElement;
  const visible = details.style.display === "block";

  if (!visible) {
    details.style.display = "block";

    wrapper.style.maxHeight = "0";
    setTimeout(() => {
      wrapper.style.maxHeight = `${details.clientHeight}px`;
    });

    setTimeout(() => {
      wrapper.style.maxHeight = "unset";
    }, 300);
  } else {
    wrapper.style.maxHeight = `${wrapper.clientHeight}px`;
    setTimeout(() => {
      wrapper.style.maxHeight = "0";
    });

    setTimeout(() => {
      details.style.display = "none";
    }, 300);
  }
};

const addSummaryListeners = (node: Element) => {
  if (node.classList.contains(SUMMARY_CLASS)) {
    node.addEventListener("click", summaryOnClick);
  }
  for (const child of node.children) {
    addSummaryListeners(child);
  }
};

export const Summary = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const [mounted, setMounted] = useState(false);
  const summaryRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    setMounted(true);
    if (summaryRef.current) {
      addSummaryListeners(summaryRef.current);
    }
  }, []);

  return (
    <>
      <Link
        className={SUMMARY_CLASS}
        data-id={id}
        href="#"
        ref={summaryRef}
        target="_blank"
      >
        {children}
      </Link>
      {mounted && (
        <Box
          className={WRAPPER_CLASS}
          style={{
            display: "inline-block",
            overflow: "hidden",
            maxHeight: 0,
            transition: "max-height 0.3s ease-out",
          }}
        />
      )}
    </>
  );
};

export const Details = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    addSummaryListeners(document.getElementById(id)!);
  }, [id]);

  return (
    <Box
      display={mounted ? "none" : "block"}
      id={id}
      borderLeftWidth="3px"
      pl={3}
    >
      {children}
    </Box>
  );
};
